/**
 * useClipTrimming
 */
import { useMemo } from 'react';
import _get from 'lodash/get';

const useClipTrimming = (mediaPlayback = {}, config = {}) => {

    const segments = useMemo(()=> {

        const playbacks = _get(mediaPlayback, 'feeds[0].playbacks', []);
        const supportedPlaybackScenarios = _get(config, 'reels.creation.supportedPlaybackScenarios', [
            'hlsCloud',
            'HTTP_CLOUD_WIRED_60',
            'HTTP_CLOUD_WIRED_WEB',
            'HTTP_CLOUD_TABLET_60',
            'HTTP_CLOUD_TABLET',
            'HTTP_CLOUD_MOBILE',
        ]);

        let highPriorityPlayback = {};

        if (playbacks.length > 0) {

            supportedPlaybackScenarios.some((supportedPlaybackScenario) => {

                const filteredPlayback = playbacks.filter((playback) => {

                    return playback.name === supportedPlaybackScenario;

                })[0];

                if (filteredPlayback) {

                    highPriorityPlayback = filteredPlayback;
                    return true;

                }

                return false;

            });

        }

        let segments = _get(highPriorityPlayback, 'segments', []);

        if (segments.length > 0) {

            segments = [
                0,
                ..._get(highPriorityPlayback, 'segments', []),
            ];

        }

        return segments;

    }, [
        mediaPlayback,
        config,
    ]);

    const canTrim = useMemo(() => {

        return segments.length >= _get(config, 'reels.creation.minSegments', 6);

    }, [
        segments,
        config,
    ]);

    return {
        segments,
        canTrim: segments.length >= _get(config, 'reels.creation.minSegments', 1),
    };

};

export default useClipTrimming;
